module.exports = __webpack_public_path__ + "static/media/home-extract.bc30c23c.jpg";